import _ from 'lodash'

// Get the path to a form page
export function getFormPagePath(pageId: string, ...suffix: string[]): string {
  return _.compact(['pages', pageId, ...suffix]).join('.')
}

// Get the path to a form category
export function getFormCategoryPath(
  pageId: string,
  categoryId: string,
  ...suffixes: string[]
): string {
  return _.compact([
    ...getFormPagePath(pageId).split('.'),
    'categories',
    categoryId,
    ...suffixes,
  ]).join('.')
}

// Get the path to a form field
export function getFormFieldPath(
  pageId: string,
  categoryId: string,
  fieldId: string,
  index?: number,
): string {
  return _.compact([
    ...getFormCategoryPath(pageId, categoryId).split('.'),
    'fields',
    index?.toString() ?? '',
    fieldId,
    'value',
  ]).join('.')
}

// Get the path to a lookup form field's isOverwritingLookup value
export function getIsOverwritingLookupFormFieldPath(
  pageId: string,
  categoryId: string,
  fieldId: string,
  index?: number,
): string {
  return _.compact([
    ...getFormCategoryPath(pageId, categoryId).split('.'),
    'fields',
    index?.toString() ?? '',
    fieldId,
    'isOverwritingLookup',
  ]).join('.')
}

// Get the path to a lookup form field's lookup cell id
export function getLookupCellIdFormFieldPath(
  pageId: string,
  categoryId: string,
  fieldId: string,
  index?: number,
): string {
  return _.compact([
    ...getFormCategoryPath(pageId, categoryId).split('.'),
    'fields',
    index?.toString() ?? '',
    fieldId,
    'lookupCellId',
  ]).join('.')
}

// Get the path to a lookup form field lookup cell ids
export function getLookupCellIdsFormFieldPath(
  pageId: string,
  categoryId: string,
  fieldId: string,
  index?: number,
): string {
  return _.compact([
    ...getFormCategoryPath(pageId, categoryId).split('.'),
    'fields',
    index?.toString() ?? '',
    fieldId,
    'lookupCellIds',
  ]).join('.')
}

// Get the path to a lookup form field lookup cells
export function getLookupCellsFormFieldPath(
  pageId: string,
  categoryId: string,
  fieldId: string,
  index?: number,
): string {
  return _.compact([
    ...getFormCategoryPath(pageId, categoryId).split('.'),
    'fields',
    index?.toString() ?? '',
    fieldId,
    'lookupCells',
  ]).join('.')
}

// Get the path to a form field's formattedValue
export function getFormattedValueFormFieldPath(
  pageId: string,
  categoryId: string,
  fieldId: string,
  index?: number,
): string {
  return _.compact([
    ...getFormCategoryPath(pageId, categoryId).split('.'),
    'fields',
    index?.toString() ?? '',
    fieldId,
    'formattedValue',
  ]).join('.')
}
